import React, { useState } from "react";
import "../styles/header.css";
import Logo from "../assets/logo.png";

import { SiTiktok, SiYoutube, SiInstagram } from "react-icons/si";
import { MdEmail } from "react-icons/md";
import { TfiFacebook } from "react-icons/tfi";
import { IoShareSocial } from "react-icons/io5";
import { GiHamburgerMenu } from "react-icons/gi";

const Header = () => {
  const [showSocialMenu, setShowSocialMenu] = useState(false);
  const [showNavMenu, setShowNavMenu] = useState(false);

  const toggleSocialMenu = () => {
    setShowSocialMenu(!showSocialMenu);
    setShowNavMenu(false);
  };

  const toggleNavMenu = () => {
    setShowNavMenu(!showNavMenu);
    setShowSocialMenu(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">

        <div className="logo">
          <a href="#hero-section">
            <img src={Logo} alt="CARPE Ministries logo" />
          </a>
        </div>

        <ul className={`main-nav ${showNavMenu ? "active" : ""}`}>
          <li>
            <a href="#about" onClick={() => setShowNavMenu(false)}>
              About
            </a>
          </li>

          <li>
            <a
              href="#programs-section"
              onClick={() => setShowNavMenu(false)}
            >
              Programs
            </a>
          </li>

          <li>
            <a href="#give-section" onClick={() => setShowNavMenu(false)}>
              Give
            </a>
          </li>

          <li>
            <a
              href="#contact-section"
              onClick={() => setShowNavMenu(false)}
            >
              Contact
            </a>
          </li>
        </ul>

        <div className="navbar-right">

          <ul className={`social-links ${showSocialMenu ? "active" : ""}`}>
            <li>
              <a
                href="https://www.facebook.com/profile.php?id=61551876666843"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                <TfiFacebook />
              </a>
            </li>

            <li>
              <a
                href="https://www.instagram.com/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <SiInstagram />
              </a>
            </li>

            <li>
              <a
                href="https://www.youtube.com/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="YouTube"
              >
                <SiYoutube />
              </a>
            </li>

            <li>
              <a
                href="https://www.tiktok.com/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="TikTok"
              >
                <SiTiktok />
              </a>
            </li>

            <li>
              <a
                href="mailto:email@gmail.com"
                aria-label="Email CARPE Ministries"
              >
                <MdEmail />
              </a>
            </li>
          </ul>

          <div className="menu-toggles">
            <button
              className="hamburger nav-toggle"
              onClick={toggleNavMenu}
              aria-label="Toggle navigation menu"
            >
              <GiHamburgerMenu />
            </button>

            <button
              className="hamburger social-toggle"
              onClick={toggleSocialMenu}
              aria-label="Toggle social menu"
            >
              <IoShareSocial />
            </button>
          </div>

        </div>

      </div>
    </nav>
  );
};

export default Header;